import React, { useContext, useState } from 'react';
import qs from 'qs';

import { useTranslation } from '@/config/i18n';
import ButtonCustom from '@/components/common/ui/button';
import { ToastContext } from '@/components/common/CommonToast';
import { toastErrorMessage, toastMessage } from '@/lib/utils';
import { apiRequest } from '@/services';
import useSearch from '@/hooks/useSearch';

const PaymentTopHeader: React.FC = () => {
  const [t] = useTranslation('');
  const { apiService } = apiRequest();
  const { toast } = useContext(ToastContext);
  const { query } = useSearch();

  const [loadingExportCsv, setLoadingExportCsv] = useState<boolean>();

  async function onExport() {
    try {
      setLoadingExportCsv(true);

      const response = await apiService.payments.collection('export-csv', {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
        params: {
          ...query,
        },
        paramsSerializer: params => qs.stringify(params, { encode: false }), 
        responseType: 'blob',
      });
  
      if (!response || !response.data) {
        toast?.current?.show(toastErrorMessage(t('common.toast.export_fail')));
        return;
      }
  
      const blob = new Blob([response.data], { type: 'text/csv;charset=utf-8;' });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `payment_list_${new Date().toISOString().slice(0, 10)}.csv`;
      a.click();
      window.URL.revokeObjectURL(url);
      toast?.current?.show(toastMessage(t('common.toast.export_csv_success')));
    } catch (e) {
      console.error('CSV Export Error:', e);
      toast?.current?.show(toastErrorMessage(t('common.toast.export_csv_fail')));
    } finally {
      setLoadingExportCsv(false);
    }
  }

  return (
    <>
      <div className="header-top flex items-center justify-between">
        <h2 className="title">
          {t('payment_list.title')}
        </h2>

        <div className="action flex items-center">
          <ButtonCustom
            severity="secondary"
            className="ml-5"
            loading={loadingExportCsv}
            onClick={onExport}
          >
            <span className="flex relative items-center">
              <span className="pi pi-upload pi-download mr-2" />
              <span>{t('payment_list.csv_output')}</span>
            </span>
          </ButtonCustom>
        </div>
      </div>
    </>
  );
};

export default PaymentTopHeader;
